import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ArrowCont,
  InfoIconCont,
  ReportsNestedHeadCont,
  ReportsNestedHeadContentCont,
  ReportsNestedHeadSortEl,
  ReportsRegularNestedHeadEl,
} from './ReportNestedTableHeaderStyles';
import { RoleNames } from '../../../../constans/routes';
import Tooltip from '../../../../HOC/Tooltip/Tooltip';
import { useAuth } from '../../../../hooks/useAuth';
import { useNestedSort } from '../../../../hooks/useNestedSort';
import Arrow from '@/assets/icons/filledDownArrow.svg?react';
import InfoIcon from '@/assets/icons/infogrey.svg?react';

const intialSort = {
  group: 'asc',
  responseRate: null,
};

interface IReportsNestedTableHeader {
  id: string;
}

const ReportsNestedTableHeader: FC<IReportsNestedTableHeader> = ({ id }) => {
  const { t } = useTranslation();
  const { getSortAscState, manageSortState } = useNestedSort(intialSort, id, 'reports');
  const { userRolesFromToken, isEBHRMember } = useAuth();

  const hideAccess = !isEBHRMember && userRolesFromToken.roles?.includes(RoleNames.Manager);

  return (
    <ReportsNestedHeadCont id="ReportsNestedHeadCont">
      <ReportsNestedHeadContentCont id="ReportsNestedHeadContentCont">
        <ReportsNestedHeadSortEl
          data-testid="ReportsHeadNameGroup"
          onClick={() => manageSortState('group')}
        >
          {t('report.nestedReportTable.header.group')}
          <ArrowCont data-testid="ArrowCont" asc={getSortAscState?.group}>
            <Arrow />
          </ArrowCont>
        </ReportsNestedHeadSortEl>
        <ReportsRegularNestedHeadEl id="ReportsRegularNestedHeadEl">
          {t('report.nestedReportTable.header.type')}
        </ReportsRegularNestedHeadEl>
        {hideAccess ? null : (
          <ReportsRegularNestedHeadEl id="ReportsRegularNestedHeadEl">
            {t('report.nestedReportTable.header.access')}
          </ReportsRegularNestedHeadEl>
        )}
        <ReportsNestedHeadSortEl
          id="ReportsNestedHeadSortEl"
          data-testid="ReportHeadNameRate"
          onClick={() => manageSortState('responseRate')}
        >
          {t('report.nestedReportTable.header.responseRate')}
          <ArrowCont data-testid="ArrowCont" asc={getSortAscState?.responseRate}>
            <Arrow />
          </ArrowCont>
          <Tooltip
            positionX="-285px"
            arrowPositionX="303px"
            positionY="24px"
            tooltipDesc={t('report.topBar.responseRateTooltip')}
          >
            <InfoIconCont id="InfoIconCont">
              <InfoIcon />
            </InfoIconCont>
          </Tooltip>
        </ReportsNestedHeadSortEl>
      </ReportsNestedHeadContentCont>
    </ReportsNestedHeadCont>
  );
};
export default ReportsNestedTableHeader;
